<template>
  <div v-if="active" class="countdown-timer">
    <div v-if="$slots.title" class="countdown-timer__title">
      <slot name="title" />
    </div>
    <div class="countdown-timer__container">
      <CountdownCard
        :key="currentDate.getDay()"
        :count="timer.d"
        :animate-count="animateCount"
        :animation-delay="animationDelay"
      >
        <template #text>Дней</template>
      </CountdownCard>
      <CountdownCard
        :key="currentDate.getHours()"
        :count="timer.h"
        :animate-count="animateCount"
        :animation-delay="animationDelay"
      >
        <template #text>Часов</template>
      </CountdownCard>
      <CountdownCard
        :key="currentDate.getMinutes()"
        :count="timer.m"
        :animate-count="animateCount"
        :animation-delay="animationDelay"
      >
        <template #text>Минут</template>
      </CountdownCard>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, onUnmounted } from "vue";
import CountdownCard from "@/components/CountdownCard.vue";

export default {
  name: "CountdownTimer",
  components: {
    CountdownCard,
  },
  props: {
    date: {
      type: Date,
      required: true,
    },
  },
  setup(props) {
    const active = ref(false);
    const preventAnimation = ref(false);
    const interval = ref(null);
    const currentDate = ref(null);

    const timer = reactive({ d: 0, h: 0, m: 0 });

    const animateCount = computed(() => (preventAnimation.value ? 1 : 3));
    const animationDelay = computed(() => (preventAnimation.value ? 0 : 500));

    const setTimer = () => {
      currentDate.value = new Date();

      timer.d = (props.date - currentDate.value) / 1000 / 60 / 60 / 24;
      timer.d = Math.trunc(timer.d);
      if (timer.d < 0) timer.d = 0;

      timer.h = props.date - currentDate.value - timer.d * 24 * 60 * 60 * 1000;
      timer.h = timer.h < 0 ? 0 : Math.trunc(timer.h / 1000 / 60 / 60);

      timer.m =
        props.date -
        currentDate.value -
        timer.d * 24 * 60 * 60 * 1000 -
        timer.h * 60 * 60 * 1000;
      timer.m = timer.m < 0 ? 0 : Math.trunc(timer.m / 1000 / 60);

      if (timer.m === 60) {
        timer.m = 0;
        timer.h += 1;
      }
      if (timer.h === 24) {
        timer.h = 0;
        timer.d += 1;
      }
    };

    const initTimer = () => {
      currentDate.value = new Date();
      active.value = props.date - currentDate.value > 0;
      if (!active.value) return;
      setTimer();
    };

    const initInterval = () => {
      interval.value = setInterval(() => {
        if (!preventAnimation.value) preventAnimation.value = true;
        setTimer();
      }, 1000 * 60);
    };

    onMounted(() => {
      initTimer();
      initInterval();
    });

    onUnmounted(() => clearInterval(interval.value));

    return {
      active,
      currentDate,
      timer,
      animateCount,
      animationDelay,
    };
  },
};
</script>

<style lang="scss" scoped>
.countdown-timer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
  width: 336px;
  padding: 10px 32px;
  background: #291f1f80;
  border-radius: 20px;
  backdrop-filter: blur(15px);

  &__title {
    font-weight: 600;
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: -0.01em;
    text-align: center;
    text-transform: uppercase;

    @include lg {
      font-size: 14px;
    }
  }

  &__container {
    display: flex;
    justify-content: space-between;
  }

  @include lg {
    width: 232px;
    padding: 10px;
    border-radius: 10px;
  }
}
</style>
